<template>
  <nav class="px-3 d-print-none" aria-label="Page navigation">
    <div class="row align-items-center">
      <div class="col stats" v-if="!hideStats">
        Found {{ pagination.total }} matching properties ({{
          pagination.elapsedTime
        }}
        seconds)
      </div>
      <div class="col" v-if="!hidePageLinks && pagination.lastPage > 1">
        <ul class="pagination pagination-sm justify-content-end">
          <li
            :class="
              pagination.currentPage === 1 ? 'page-item disabled' : 'page-item'
            "
          >
            <router-link
              class="page-link"
              :to="{
                name: 'county',
                query: qs(pagination.currentPage - 1),
              }"
              :aria-disabled="pagination.currentPage === 1 ? 'true' : null"
              :tabindex="pagination.currentPage === 1 ? -1 : null"
              >Previous</router-link
            >
          </li>
          <li
            v-for="(n, index) in visiblePages"
            :key="index"
            :class="
              pagination.currentPage === n ? 'page-item active' : 'page-item'
            "
            :aria-current="n === pagination.currentPage ? 'page' : null"
          >
            <router-link
              v-if="n"
              :class="
                pagination.currentPage === n
                  ? 'page-link disabled'
                  : 'page-link'
              "
              :to="{ name: 'county', query: qs(n) }"
              :aria-disabled="pagination.currentPage === n ? 'true' : null"
              :tabindex="pagination.currentPage === n ? -1 : null"
              >{{ n }}</router-link
            >
            <span v-else-if="n === 0" class="page-link">...</span>
          </li>
          <li
            :class="
              pagination.currentPage === pagination.lastPage
                ? 'page-item disabled'
                : 'page-item'
            "
          >
            <router-link
              class="page-link"
              :to="{
                name: 'county',
                query: qs(pagination.currentPage + 1),
              }"
              :aria-disabled="
                pagination.currentPage === pagination.lastPage ? 'true' : null
              "
              :tabindex="
                pagination.currentPage === pagination.lastPage ? -1 : null
              "
              >Next</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.stats {
  font-size: small;
}
.page-item {
  font-weight: 700;
}
</style>

<script>
export default {
  computed: {
    pagination() {
      return {
        currentPage: this.item.page + 1,
        elapsedTime: this.item.elapsedTime,
        from: this.item.page * this.item.perPage + 1,
        lastPage: Math.ceil(this.item.numRecords / this.item.perPage),
        perPage: this.item.perPage,
        to: (this.item.page + 1) * this.item.perPage,
        total: this.item.numRecords,
      };
    },
    visiblePages() {
      let arr = [];
      for (let i = 1; i <= this.pagination.lastPage; i++) {
        if (this.pagination.lastPage < 9) {
          arr.push(i);
        } else if (i <= 2) {
          arr.push(i);
        } else if (i >= this.pagination.lastPage - 1) {
          arr.push(i);
        } else if (
          i > this.pagination.currentPage - 2 &&
          i < this.pagination.currentPage + 2
        ) {
          arr.push(i);
        } else if (arr[arr.length - 1] !== 0) {
          arr.push(0);
        }
      }
      return arr;
    },
  },
  methods: {
    qs(page) {
      let q = {};
      if (this.$route.query.ownerName)
        q.ownerName = this.$route.query.ownerName;
      if (this.$route.query.address) q.address = this.$route.query.address;
      if (this.$route.query.parcelNumber)
        q.parcelNumber = this.$route.query.parcelNumber;
      if (this.$route.query.duplicateNumber)
        q.duplicateNumber = this.$route.query.duplicateNumber;
      q.page = page;
      return q;
    },
  },
  props: {
    hidePageLinks: {
      default: false,
      required: false,
      type: Boolean,
    },
    hideStats: {
      default: false,
      required: false,
      type: Boolean,
    },
    item: {
      required: true,
      type: Object,
    },
  },
};
</script>
